export default {
  myAccount: {
    profile: 'Profile',
    pageTitle: 'My account'
  }
}
